import {DateTime} from 'luxon';
import {useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import useVisualizationParams from './useVisualizationParams.ts';
import {useGetCatalogSearch} from '@src/api/catalog';
import {useGetConfigurationLayer} from '@src/api/configurations';
import {RootState} from '@src/store.ts';

export const useAvailableDates = (
  defaultSearchRange: {
    from: DateTime | null;
    to: DateTime | null;
  },
  options: {enabled?: boolean} = {enabled: true},
) => {
  const [searchRange, setSearchRange] = useState(() => {
    return {
      from: defaultSearchRange.from || DateTime.now().startOf('month'),
      to: defaultSearchRange.to || DateTime.now().endOf('month'),
    };
  });

  const {configurationId, layerId} = useVisualizationParams();
  const layer = useGetConfigurationLayer(configurationId, layerId).data;
  const collectionId = layer?.collectionId;

  const mapExtent = useSelector((state: RootState) => state.map.extent);

  const {data, isLoading} = useGetCatalogSearch<string>(
    {
      bbox: mapExtent ?? undefined,
      datetime: `${searchRange.from.toISO()}/${searchRange.to.toISO()}`,
      collections: [collectionId || ''],
      limit: 65,
      distinct: 'date',
    },
    {enabled: options.enabled},
  );

  const availableDates: DateTime[] = useMemo(() => {
    if (!data?.features) {
      return [];
    }

    return data.features.map((feature: string) => DateTime.fromISO(feature));
  }, [data]);

  return {
    searchRange,
    setSearchRange,
    availableDates,
    isLoading,
  };
};
